export const NOT_SPECIFIED = 'k. A.';
export const PALM_MAX = 668;
export const LAP_MIN = 669;
export const LAP_MAX = 1013;
export const DESK_MIN = 1014;
export const NO_DATA_TEXT = 'Momentan stehen keine Informationen zur Verfügung.';
export const CONTACT_REALTOR = 'Anbieter kontaktieren';
export const SHOW_EXPOSE = 'Exposé anzeigen';
export const MAP_PATH = 'karte';
export const NO_PRICE_RANGE = 'Kein Preis vorhanden';
export const EAGERLY_LOADING_LISTINGS_TTL = 24 * 60 * 60 * 1000;
export const SIDEBAR_FOLDED_STATE_TTL = 24 * 60 * 60 * 1000;

export const GEO_HIERARCHY_LEVELS = {
  country: 'country',
  region: 'region',
  city: 'city',
  district: 'district',
  street: 'street',
  address: 'address',
};

export * from './featureFlags';

/* Place to set local storage keys */
export const IS_EAGERLY_LOADING_LISTINGS = 'IS_EAGERLY_LOADING_LISTINGS';
export const IS_SIDEBAR_DESKTOP_EXPANDED = 'IS_SIDEBAR_DESKTOP_EXPANDED';
export const DID_COMPLETE_SURVEY = 'DID_COMPLETE_SURVEY';
